export const fi = {
  returnLineItems: {
    refund: "Hyvitys/hyvitykset",
    exchange: "Vaihto/vaihdot",
    discount: "Alennus/alennukset",
  },
  returnStoreAddress: {
    mapButton: "Näytä kartalla",
  },
  downloadLabel: {
    label: "Lataa osoitetarrani",
    bonDeRetour: "Lataa palautuslomakkeeni",
  },
  returnRequestDate: {
    label: "Palautuspyyntösi tehtiin {{date}} klo {{time}}",
  },
  actions: {
    continue: "Jatka",
  },
  "order-identification": {
    title: "Seuraa tilaustasi",
    description: "Syötä tilaustietosi seurataksesi pakettiasi",
    fields: {
      "zip-code": {
        title: "Postinumero",
        description: "Syötä toimituspostinumerosi",
        required: "Postinumero on pakollinen",
      },
      email: {
        title: "Sähköpostiosoite",
        description: "Syötä tilauksessasi käyttämäsi sähköpostiosoite",
        required: "Sähköpostiosoite on pakollinen",
      },
      "tracking-number": {
        title: "Tilausnumero",
        description: "Syötä tilausnumerosi",
        required: "Tilausnumero on pakollinen",
      },
    },
    errors: {
      "unknown-order": {
        title: "Tuntematon tilausnumero",
        description: "Tilausnumeroa ei löytynyt, tarkista se",
      },
      "search-error": {
        title: "Hakuvirhe",
        description: "Tilausta ei löytynyt. Yritä myöhemmin uudelleen.",
      },
    },
  },
  delivery: "Toimitus",
  "parcel-history": "Paketin historia",
  "order-details": {
    title: "Tilauksen tiedot",
    "tracking-number": "Seurantanumero",
    "order-number": "Tilausnumero",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Arvioitu toimituspäivä",
      deliveredOn: "Toimitettu",
      from: "alkaen",
      to: "asti",
    },
  },
  deliveryAddress: {
    title: "Toimitusosoite:",
    titlePickup: "Noutopisteen osoite:",
    orderDetails: {
      title: "Tilauksen tiedot:",
      trackingNumber: "Seurantanumero:",
      orderNumber: "Tilausnumero:",
      orderDate: "Tilauspäivä:",
    },
  },
  pickupPoint: {
    title: "Noutopiste",
    openingHours: "Aukioloajat:",
    closed: "Suljettu",
    directions: "Reittiohjeet",
    days: {
      monday: "Maanantai:",
      tuesday: "Tiistai:",
      wednesday: "Keskiviikko:",
      thursday: "Torstai:",
      friday: "Perjantai:",
      saturday: "Lauantai:",
      sunday: "Sunnuntai:",
    },
  },
  wallet: {
    warningNotEnabled: "Sinun täytyy ottaa Wallet käyttöön kaupan asetuksissa",
  },
  crossSell: {
    youMightAlsoLike: "Saatat pitää myös",
  },
  "rate-order": {
    "order-recap": {
      title: "Tilauksesi",
      "tracking-label": "Seurantanumero:",
      "order-label": "Tilausnumero:",
    },
    form: {
      title: "Arvioi toimituksesi",
      "rating-label": "Arvioi toimituskokemuksesi",
      "comment-label": "Kommentti (valinnainen)",
      "comment-placeholder": "Kerro kokemuksestasi meille…",
      "submit-cta": "Lähetä arviointi",
      "update-cta": "Päivitä arviointi",
      "rating-required": "Valitse arvosana.",
    },
    "thank-you": {
      title: "Kiitos palautteestasi!",
      description:
        "Arviointisi on tallennettu. Se auttaa meitä parantamaan toimituskokemusta.",
    },
    errors: {
      "invalid-token": {
        title: "Virheellinen tai vanhentunut linkki",
        description:
          "Tämä linkki ei ole enää voimassa. Avaa se uudelleen viimeisimmästä seurantaviestistäsi.",
      },
      submit: {
        title: "Jotain meni pieleen",
        description:
          "Emme voineet tallentaa arviointiasi. Yritä myöhemmin uudelleen.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Voit nyt tulostaa palautustarrasi ja jättää pakettisi lähimpään Colissimo-lähipisteeseen.",
    chronoShop2Shop: "Voit nyt tulostaa palautustarrasi ja jättää pakettisi lähimpään Chronopost-lähipisteeseen.",
    ups: "Voit nyt tulostaa palautustarrasi ja jättää pakettisi lähimpään UPS-lähipisteeseen.",
    customerCarrier: "Voit nyt lähettää palautuspakettisi valitsemallesi kuljetusyritykselle.",
    merchantCarrier: "Lähetämme sinulle palautustarran sähköpostitse 1–3 arkipäivän kuluessa.",
    returnToStore: "Voit nyt jättää pakettisi lähimpään myymälään.",
    malca: "Voit nyt tulostaa palautustarrasi ja jättää pakettisi lähimpään Malca-lähipisteeseen.",
    tnt: "Voit nyt tulostaa palautustarrasi ja jättää pakettisi lähimpään TNT-lähipisteeseen.",
    bonDeRetour: "Lähetyslappusi on valmis. Voit nyt tulostaa sen ja käyttää palautuksessasi.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Toimitustarrasi on valmis",
    bonDeRetour: "Palautuslomakkeesi on valmis",
  },
} as const;
